import { ShowDate } from 'framework/ui/ui-builder';
import { DATE_FORMAT } from '../../../utils/hooks/useDateService';
import useFieldHelper from '../fieldHelper';
import TextField from '../text/TextField';
import { FieldProps } from '../types';

export interface FullDateFieldProps extends FieldProps {
  showSeconds?: boolean;
}

const FullDateField = ({ showSeconds, ...props }: FullDateFieldProps) => {
  const { getValue, getLabel } = useFieldHelper(props);

  const format = showSeconds ? DATE_FORMAT.FULL_WITH_SECONDS : DATE_FORMAT.FULL;

  const value = getValue() && <ShowDate dateUTC={getValue()} format={format} />;

  return <TextField label={getLabel()} value={value} />;
};

export default FullDateField;
